
import React, { Component } from 'react';
import {Modal, Form, Input} from 'antd';
import http from "../../../axios/http";
import messager from "../../ui/messager";

const FormItem = Form.Item;





class FinancialAuditEditForm extends Component {

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }

            let memberCode = this.props.editData.memberCode
            if (memberCode !== undefined && memberCode != null) {
                values["memberCode"] = memberCode;
            } else {
                values["memberCode"] = 1;
            }

            http.post({
                url: '/financial/audit/edit',
                data: values,
                success: (res) => {
                    messager.notify("保存成功！");
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                }
            });
        });
    };

    render() {
        const { visible, onCancel, form, editData } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                visible={visible}
                title="审核信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    <FormItem label="备注：">
                        {getFieldDecorator('remark', {
                            initialValue: editData.remark,
                        })(
                            <Input.TextArea />
                        )}
                    </FormItem>
                </Form>
            </Modal>
        );
    }
}
const FinancialAuditEdit = Form.create()(FinancialAuditEditForm);

export default FinancialAuditEdit;